import { useAtom } from "jotai";
import { useMemo } from "react";
import { createNotificationsAtom } from "./atoms";

/**
 * Hook to fetch notifications with infinite scroll support
 * Each call with different parameters creates an independent query
 * TanStack Query handles caching and deduplication automatically
 * 
 * @param notification_type - Type of notifications to fetch
 * @param unread_only - Whether to fetch only unread notifications
 * @param search - Optional search query
 * @returns Infinite query result with notifications data
 */
export function useNotifications(
  notification_type: "live_alert" | "accessibility_information" | "all" = "all",
  unread_only: boolean = false,
  search?: string
) {
  // Create a memoized atom with the specific filters
  // This ensures each unique combination of parameters gets its own query
  const notificationsAtom = useMemo(
    () => createNotificationsAtom(notification_type, unread_only, search),
    [notification_type, unread_only, search]
  );
  
  // Get the notifications query from the atom
  const [notificationsQuery] = useAtom(notificationsAtom);

  // Return the query result
  return notificationsQuery;
}
